module.exports = __webpack_public_path__ + "img/index_banner4.4a37e753.png";